import { atomFamily } from 'recoil';

var FormFieldKey;
(function (FormFieldKey) {
    FormFieldKey["IMPORT"] = "import";
})(FormFieldKey || (FormFieldKey = {}));
var formFieldsAtom = atomFamily({
    key: "FormFieldsAtom",
    "default": []
});
var formFieldThesaurusOptionsToLoadState = atomFamily({
    key: "FormFieldThesaurusOptionsToLoadState",
    "default": undefined
});
var formFieldThesaurusOptionsState = atomFamily({
    key: "FormFieldThesaurusOptionsState",
    "default": []
});

export { FormFieldKey, formFieldThesaurusOptionsState, formFieldThesaurusOptionsToLoadState, formFieldsAtom };
//# sourceMappingURL=atoms.js.map
